import * as React from 'react'

import { BrandingHostnameProvider } from '@/hooks/use-branding'

import ReactQueryContext from '@/contexts/react-query-provider'
import { TenantConfig } from '@/services/tenant.service'

import { AuthProvider } from './auth-context'
import { ChatProvider } from './chat-context'
import { FeatureFlagProvider } from './feature-flag-context'
import { ForumUnreadProvider } from './forum-unread-context'
import { NotificationProvider } from './notification-context'
import { SocketProvider } from './socket-context'
import { TenantProvider } from './tenant-context'

interface ProvidersProps {
  children: React.ReactNode
  initialTenantId?: string
  initialTenantConfig?: TenantConfig | null
  initialHostname?: string
}

export default function Providers({ children, initialTenantId, initialTenantConfig, initialHostname }: ProvidersProps) {
  const hostname = initialHostname || (typeof window !== 'undefined' ? window.location.hostname : '')

  return (
    <ReactQueryContext>
      <TenantProvider initialTenantId={initialTenantId} initialConfig={initialTenantConfig}>
        <BrandingHostnameProvider hostname={hostname}>
          <FeatureFlagProvider hostname={hostname}>
            <AuthProvider>
              <SocketProvider>
                <ChatProvider>
                  <NotificationProvider>
                    <ForumUnreadProvider>{children}</ForumUnreadProvider>
                  </NotificationProvider>
                </ChatProvider>
              </SocketProvider>
            </AuthProvider>
          </FeatureFlagProvider>
        </BrandingHostnameProvider>
      </TenantProvider>
    </ReactQueryContext>
  )
}
